<template>
  <transition name="modal">
    <div
      v-if="modal.open"
      class="vue-modal modal-mask credits-modal"
      @click="closeModal($event.target)"
    >
      <div class="vue-modal--wrapper">
        <div class="vue-modal--container credits-modal--container">
          <button type="button" class="close" @click="closeModal(false)">
            <svg class="rbi">
              <use
                xlink:href="/static/assets/images/rbi-icon.svg#rbi-close"
              ></use>
            </svg>
          </button>
          <div v-if="sex.isMan" class="modal-body credits-modal--body">
            <h4 class="modal-title">Oops</h4>
            <p class="text-muted">
              Something went wrong while trying to receive a stream from the
              camera...
            </p>
            <p v-if="isIos" class="text-muted">
              Please use Safari browser to broadcast your camera.
            </p>
          </div>
          <div v-else class="modal-body credits-modal--body">
            <h4 class="modal-title">Упс</h4>
            <p class="text-muted">
              Что-то пошло не так при попытке получить видео с камеры...
            </p>
            <p v-if="isIos" class="text-muted">
              Пожалуйста используйте Safari для демонстрации своей камеры.
            </p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'GetUserMediaErrorModal',
  data() {
    return {};
  },
  computed: {
    modal() {
      return this.$store.getters.getUserMediaModal;
    },
    app() {
      return this.$store.getters.app;
    },
    sex() {
      return this.$store.getters.sex;
    },
    isIos() {
      return this.$store.getters.device.isIOS;
    },
  },
  methods: {
    closeModal(e) {
      if (!$(e).closest('.mail-modal--body').length || !e) {
        this.$store.commit('updateGetUserMediaModal', {
          open: false,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.credits-modal {
  &--container {
    width: 320px;
    position: relative;
  }

  h4 {
    font-weight: bold;
    color: #656565;
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  &--body {
    text-align: center;
    p {
      margin: 20px 0;
    }
  }

  .btn-success {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    border: none !important;
    padding: 6px 20px;

    span + span {
      margin-left: 10px;
    }

    svg {
      height: 20px;
      width: 20px;
      fill: currentColor;
    }
  }
}
</style>
